import { useState, useEffect } from "react";
import { motion } from "framer-motion";

const links = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Projects", href: "#projects" },
];

export default function Navigation() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleClick = (href) => (e) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div
      data-testid="main-navigation"
      className="fixed top-4 sm:top-6 left-0 right-0 z-50 flex justify-center pointer-events-none px-4"
    >
      <motion.nav
        initial={{ y: -40, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        className={`pointer-events-auto transition-transform duration-300 ${
          scrolled ? "scale-[0.97]" : "scale-100"
        }`}
      >
        <div className="flex items-center gap-1 sm:gap-2 px-2 py-2 rounded-full bg-zinc-900/90 backdrop-blur-md border border-white/10 shadow-[0_8px_32px_rgba(0,0,0,0.35)]">
          {/* Logo */}
          <a
            href="#home"
            onClick={handleClick("#home")}
            data-testid="nav-logo"
            className="flex items-center pl-1 pr-2 py-0.5 rounded-full"
          >
            <img
              src="https://customer-assets.emergentagent.com/job_site-starter-kit-6/artifacts/spvwyi7u_Frame%201.png"
              alt="Obiajulu Anayo"
              className="h-9 w-9 rounded-full object-cover ring-1 ring-white/20"
            />
          </a>

          <div className="hidden sm:flex items-center">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={handleClick(l.href)}
                data-testid={`nav-link-${l.label.toLowerCase()}`}
                className="text-sm text-zinc-300 hover:text-white transition-colors px-4 py-2 rounded-full hover:bg-white/5"
              >
                {l.label}
              </a>
            ))}
          </div>

          <a
            href="mailto:obiianayo@gmail.com"
            data-testid="nav-lets-talk-btn"
            className="ml-1 inline-flex items-center gap-2 bg-white text-zinc-900 hover:bg-brand-500 hover:text-white transition-colors text-sm font-medium px-4 py-2 rounded-full"
          >
            Let&apos;s talk
            <span className="inline-block h-1.5 w-1.5 rounded-full bg-brand-500"></span>
          </a>
        </div>
      </motion.nav>
    </div>
  );
}
